import { ManualEditState } from "@/api/images-types";
import { pretty } from "@/utils/pretty";
import { green, grey, red } from "@mui/material/colors";
import { StateChip, StateChipProps } from "./StateChip";
import { SyntheticEvent } from "react";

type Props = {
  state: ManualEditState | null;
  size?: StateChipProps["size"];
  onDelete?: (event: SyntheticEvent) => void;
};

const colors = {
  unfixed: red[400],
  downloaded: grey[400],
  awaiting_mask: grey[400],
  fixed: green[400],
};

export function ManualEditStateChip({ state, size, onDelete }: Props) {
  return (
    <StateChip
      size={size}
      label={pretty(state || ManualEditState.unfixed)}
      color={colors[state || ManualEditState.unfixed]}
      onDelete={onDelete}
    />
  );
}
